.betaTag {
  vertical-align: super;
  font-size: 0.8em;
  font-weight: 300;
  color: var(--negative-50);

  &.notInCore {
    margin-left: 14px;
  }
}
